import React, { useState } from "react";
import { Box, Button } from "@material-ui/core";
import { css } from "@emotion/css";
import HtmlText from "./HtmlText";
import { LocalizedQuestion } from "../../types";
import { readLocale } from "../../utils";

type Props = { question: LocalizedQuestion | undefined; locale: string };

const QuizScreen: React.VFC<Props> = ({ question, locale }) => {
  const [selected, setSelected] = useState<number | null>(null);
  if (!question) return <Box p={2}>No question</Box>;

  return (
    <Box className={styles.wrap}>
      <HtmlText html={readLocale(question.title, locale) || "Untitled question"} className={styles.q} component="h6" />
      <Box className={styles.answers}>
        {(question.answers ?? []).map((a, i) => {
          const isSelected = selected === i;
          const isCorrect = a.correct;
          return (
            <Button
              key={i}
              variant="outlined"
              fullWidth
              onClick={() => setSelected(i)}
              style={{
                borderColor: isSelected ? (isCorrect ? "#4caf50" : "#f44336") : undefined,
                background: isSelected ? (isCorrect ? "#e8f5e9" : "#ffebee") : undefined,
              }}
            >
              {readLocale(a.text, locale) || `Answer ${i + 1}`}
            </Button>
          );
        })}
      </Box>
      {selected !== null && readLocale(question.tipDescription, locale) && (
        <HtmlText html={readLocale(question.tipDescription, locale)} className={styles.tip} />
      )}
    </Box>
  );
};

export default React.memo(QuizScreen);

const styles = {
  wrap: css`
    padding: 16px;
    height: 100%;
    overflow-y: auto;
  `,
  q: css`
    font-weight: 700;
    margin-bottom: 12px;
  `,
  answers: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  tip: css`
    margin-top: 4px;
    color: #555;
  `,
};
